module.exports = __webpack_public_path__ + "static/media/main.69e5f7ed.png";